import script from "./HelperTip.vue?vue&type=script&setup=true&lang=ts"
export * from "./HelperTip.vue?vue&type=script&setup=true&lang=ts"

import "./HelperTip.vue?vue&type=style&index=0&id=5d978a35&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d978a35"]])

export default __exports__